module.exports = __webpack_public_path__ + "img/partnersEight.b4af74e9.png";